import React, { useState } from "react";
import { useParams } from "react-router";
import { BASE_URL } from "../../../api";
import "./Reupload.css";

function App() {
  const [baseVideo, setBaseVideo] = useState("");
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileName, setFileName] = useState("");
  const [isError, setIsError] = useState("");
  const params = useParams();

  const handleFileInputChange = async (e) => {
    const file = e.target.files[0];
    const duration = await getVideoDuration(file);
    if (duration <= 60) {
      const base64 = await convertBase64(file);
      // console.log(base64);
      setBaseVideo(base64);
      setFileName(file.name); // update the file name state
      setIsError(""); // clear error message if previously set
    } else {
      setBaseVideo("");
      setIsError("Please upload a video that is less than 60 seconds");
    }
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = URL.createObjectURL(file);
    });
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!baseVideo) {
      setIsError("Please select a video to upload.");
      return;
    }

    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}students/reupload_video/`, {
      method: "POST",
      body: JSON.stringify({
        id: params?.id,
        video: baseVideo,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const responseData = await response.json();
    // console.log(responseData); // log the fetched data

    if (responseData.is_reupload === 200) {
      const errorMessage = await response.text();
      console.log(errorMessage);
    } else {
      setIsUploaded(true);
    }
  };

  return (
    <>
      <div className="Re_upload_Video">
        {!isUploaded ? (
          <form onSubmit={handleSubmit}>
            <div className="reupload-Warning">
              <p>Re-uploading of your video only one attempt allowed</p>
            </div>
            <div className="Reupload-profile-video">
              <div className="file-input-reupload_video">
                <label
                  htmlFor="video-input"
                  className="file-input-reupload_label"
                >
                  <div className="file-input-icon">
                    <i className="fa-solid fa-circle-arrow-up" />
                    <i />
                    <div className="file-input-text">
                      {fileName || "Select & Re-upload video"}{" "}
                      {/* show file name if available */}
                    </div>
                  </div>
                </label>
                <input
                  id="video-input"
                  type="file"
                  className="file-input_reupload"
                  accept="video/*"
                  onChange={handleFileInputChange}
                />
              </div>
            </div>
            <div className="Reupload_submit_button">
              <button type="submit" className="Re_upload_submit">
                Upload
              </button>
              {isError && <p className="error_reupload">{isError}</p>}
            </div>
          </form>
        ) : (
          <div className="Video-success-msg">
            <center>
              <p>
                Video uploaded successfully!
                <br />
                Please refresh the page to view the updated version of your
                video.
              </p>
            </center>
          </div>
        )}
      </div>
    </>
  );
}

export default App;
